import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

const toOption = (contract) => ({
  label: `(${contract.status}) ${contract.documentNumber} - ${contract.socialReason}`,
  value: contract.id,
});

class BillContractSelectService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      contracts: [],
      fetching: false,
    });
  }

  handleSearch = action((value = null) => {
    this.fetching = true;
    this.fetch
      .fetch({
        url: '/contracts',
        apiVersion: 'v2',
        query: {
          status: ['ACTIVE', 'AWAITING_INITIAL_PAYMENT', 'BLOCKED'],
          page: 1,
          size: 20,
          ...(value && {
            criteria: value,
          }),
        },
      })
      .then(
        action(() => {
          this.fetching = false;
          if (this.fetch.data) {
            this.contracts = this.fetch.data.docs.map(toOption);
          }
        })
      );
  });

  load = action(() => this.handleSearch(null));

  handleFindContract = action((contractId) => {
    if (!contractId || this.contracts.find((contract) => contract.value === contractId)) return;
    this.fetch.fetch({ url: `/contracts/${contractId}`, apiVersion: 'v2' }).then(() => {
      if (this.fetch.data && !this.contracts.find((contract) => contract.value === this.fetch.data.id)) {
        this.contracts = [toOption(this.fetch.data), ...this.contracts];
      }
    });
  });
}

export default BillContractSelectService;
